// src/services/auth.js
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const applicationsApi = createApi({
  reducerPath: "applications",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_BACKEND_URL}/api/applications/`,
    prepareHeaders: (headers, { getState }) => {
      const token = localStorage.getItem("token");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ["Applications"],
  endpoints: (builder) => ({
    selectApplication: builder.mutation({
      query: ({ userID, applicationType }) => ({
        url: "select",
        method: "POST",
        body: { userID, applicationType },
      }),
    }),
  }),
});

export const { useSelectApplicationMutation } = applicationsApi;

export default applicationsApi;
export { applicationsApi };
